<template>
  <div class="page height-full">
    <app-header title="New Campaign"/>

    <b-card v-if="!showPreview">
      <md-dialog-content class="dialog-content">
        <div class="row">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-md-12">
                <label for="input-campaign-name">Campaign Name</label>
                <input type="text" 
                       class="form-control" 
                       id="input-campaign-name"
                       placeholder="Campaign Name"
                       v-model="form.name" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <br />
                <div class="form-group">
                  <label for="input-campaign-msg">Message</label>
                  <textarea class="form-control" 
                            id="input-campaign-msg"
                            placeholder="Write Something..." rows="6"
                            v-model="form.message" required/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="input-campaign-list">Send To</label><br>
                  <b-form-select v-model="form.selected" :options="options" id="input-campaign-list"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row">
              <div class="col-md-12">
                <div class="card phone">
                  <div class="screen">
                    <div class="text-container">
                      <p>{{phoneMessage}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-dialog-content>
      <br />
      <md-dialog-actions>
        <div class="row" style="float:right;">
          <b-button  @click="cancel">Cancel</b-button>
          <b-button v-if="validCampaign" id="campaign-preview-btn" variant="primary" class="ml-2 mr-3" @click="showPreview = true">Preview</b-button>
          <b-button v-else="validCampaign" variant="primary" class="ml-2 mr-3" disabled>Preview</b-button>
        </div>
      </md-dialog-actions>
    </b-card>
    <b-card v-else>
      <b-icon-arrow-left @click="showPreview = false" font-scale="1.5" class="text-blue ml-3 mr-3"></b-icon-arrow-left> 
      <br /><br />
      <b-col md="10" offset="1"><label for="validationCustom01">{{form.name}}</label>
        <div class="message-container p-3 mt-2 mb-4">
          <p>{{form.message}}</p>
          <a href="#" @click="showPreview = false">Edit Message</a>
        </div>
        <b-row>
          <b-col md="6" class="pt-3">
            <b class="">{{confirmationString()}}</b><b-icon-info-circle-fill v-b-tooltip.hover title="Each message = 1 credit."></b-icon-info-circle-fill>
          </b-col>
          <b-col md="6">
              <b-button variant="primary" id="campaign-create-btn" class="ml-2" @click="createCampaign()"  style="float:right;">Send Now</b-button>
              <!-- <b-button  v-b-modal.schedule-modal  style="float:right;">Schedule</b-button> -->
              <b-modal id="schedule-modal" title="Schedule Campaign">
                <label for="example-datepicker">Campaign date</label>
                <b-form-datepicker id="campaign-datepicker" v-model="date" class="mb-2"></b-form-datepicker>
                <p>Value: '{{ date }}'</p>
                <label for="timepicker-sm">Campaign time</label>
                <b-form-timepicker 
                  id="campaign-timepicker" 
                  v-model="time"
                  class="mb-2"
                  hour12="true"></b-form-timepicker>
                  <p>Value: '{{ time }}'</p>
              </b-modal>
          </b-col>
        </b-row>
      </b-col>
    </b-card>
  </div>
</template>

<script>
  import axios from "axios"
  import Constants from "../../Constants"
  import Spinner from '../common/Spinner'

  export default {
    name: "NewCampaign",
    components: {
      Spinner
    },
    data: () => ({
      showDialog: false,
      isLoading: false,
      isLoadingLists: false,
      showPreview: false,
      showMobileCampaign: false,
      campaigns: [],
      lists: [],
      selected: {
        message: '',
        status: '',
        recipients: []
      },
      form: {
        name: "",
        message: "",
        selected: [],
      },
      options: [], // [{value: 'ALL', text: 'All'}],
      listQueryText: '',
      date: '',
      time: ''
    }),
    computed: {
      getNumberSubscribers() {
        if (this.form.selected.length > 0)
          if (this.form.selected[0] === "ALL")
            return "all"
        return this.form.selected.length
      }, 
      showCampaignDetail() {
        return this.campaigns.length > 0
      },
      getSubscriberCount() {
        var subCount = 0
        const selectedId = "list|" + this.form.selected
        this.lists.forEach((list) => {
          if (list.sk == selectedId) {
            subCount = list.subscriberCount
          }
        })
        return subCount
      },
      getCreditCount() {
        return this.getSubscriberCount
      },
      phoneMessage() {
        if (this.form.message.length > 0) {
          return this.form.message
        } else {
          return "Your campaign message will appear here..."
        }
      },
      validCampaign() {
        return this.form.message.length > 0 && this.form.name.length > 0 && this.form.selected.length > 0
      }
    },
    methods: {
      getCampaigns() {
        this.isLoading = true
        axios
          .get(Constants.API_URL + "/campaigns")
          .then(response => {
            console.log(response);
            this.campaigns = response.data.Items
            if (this.campaigns.length > 0)
              this.changeSelected(this.campaigns[0])
          }).catch((err) => {
            if (err.response.status == 401) {
              window.location.href = "/campaigns"
            }
          }).then(() => {
            this.isLoading = false
          })
      },
      getLists() {
        this.isLoadingLists = true
        axios
          .get(Constants.API_URL + "/lists")
          .then(response => {
            this.lists = response.data.Items
            response.data.Items.forEach((item) => {
              console.log(item)
              this.options.push({value: item.sk.split('|')[1], text: item.name + " (" + item.subscriberCount + ")", count: item.subscriberCount});
            })
          }).catch((err) => {
            console.log(err)
          }).then(() => {
          this.isLoadingLists = false
        })
      },
      confirmationString() {
        var recipients = 'recipients'
        var credits = 'credits'
        if (this.getSubscriberCount == 1) {
          recipients = 'recipient'
          credits = 'credit'
        }
        return 'Sending to ' + this.getSubscriberCount +  ' ' + recipients + ' for ' + this.getCreditCount +  ' ' + credits + '. '
      },
      changeSelected(campaign) {
        this.selected = campaign
        if (document.documentElement.clientWidth < 992) {
          this.showMobileCampaign = true 
        }
      },
      getRecipientsList(recipients) {
        if (recipients === undefined) return ""

        if (recipients.length > 0) {
          return recipients.join(", ")  
        } else {
          return ""
        }      
      },
      getRecipients(recipients) {
        if (recipients === undefined) return ""
        if (recipients.length == 0) return ""

        const tmp = recipients.split(",")
        let result = ""
        tmp.forEach((item) => {
          result += (Constants.FORMAT_PHONE_NUMBER(item) + "<br>")
        })
        return result
      },
      reset() {
        this.form.name = "";
        this.form.message = "";
        this.form.selected = [];
      },
      cancel() {
        // window.location.href = '/campaigns'
        this.$router.go(-1)
      },
      previewMessage() {
        if (this.form.name == '') {
          swal('', 'Please enter a campaign name.', 'warning')
        } else if (this.form.message == '') {
          swal('', 'Please enter a campaign message.', 'warning')
        } else if (this.form.selected.length == 0) {
          swal('', 'Please select recipients for your campaign.', 'warning')
        } else {
          this.showPreview = true
        }
      },
      createCampaign() {
        const params = {
          name: this.form.name,
          message: this.form.message,
          recipientsLists: [this.form.selected],
        }
        this.isLoading = true
        axios.post(Constants.API_URL + "/campaigns", params)
          .then(response => {
            console.log(response);
            Appcues.track('Create Campaign')
            return swal(
              'Campaign Created', 'Your campaign has been saved and is pending review.', 'success'
            )
          })
          .then(() => {
            window.location.href = "/campaigns"
          })
          .catch((err) => {
            console.log(err)
            const msg = 'Error creating campaign. Make sure your list has subscribers before creating a campaign.'
            swal('', msg, 'error')
          }).then(() => {
            this.isLoading = false
          })
      }
    },
    mounted() {
      this.getCampaigns()
      this.getLists()
    }
  }
</script>

<style scoped>
  .dialog-content {
    max-height: 600px;
    width: 100%;
  }

  .md-dialog-container {
    width: 50%;
  }

  .card-height {
    min-height: 600px;
  }

  .selected {
    background-color: #F5F8FA;
  }

  .message-container {
    border: 1px solid #d7d7d7;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/campaigns/NewCampaign.vue